import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from './../../../src/environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';


@Injectable()
export class SaveAlumniDetaisService extends BehaviorSubject<GridDataResult> {

  SERVER_API = environment.WCUAlumniAPI_URL + 'api/Alumni';
  // SERVER_API = 'http://localhost:65197/api/Alumni';

  constructor(private http: HttpClient) {
    super(null);
  }

  SaveAlumniDetails(data): Observable<any> {
    return this.http.post(this.SERVER_API + '/SaveAlumni', data).map((res: Response) => {
      return res;
    });
  }

  SaveCurrentlyWork(data): Observable<any> {
    return this.http.post(this.SERVER_API + '/SaveCurrentlyWork', data).map((res: Response) => {
      return res;
    });
  }

  getCampusList(): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetWCUCampusList').map((res: Response) => {
      return res;
    });
  }

  getStateList(): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetStateList').map((res: Response) => {
      return res;
    });
  }

  getCityList(data): Observable<any> {
    return this.http.post(this.SERVER_API + '/GetCityList', data).map((res: Response) => {
      return res;
    });
  }

  getWhereDoYouWorkList(): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetSitesList').map((res: Response) => {
      return res;
    });
  }

  getWhatIsYourSpecialtyList(): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetDepartmentList').map((res: Response) => {
      return res;
    });
  }

  getDegreeList(): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetDegreeList').map((res: Response) => {
      return res;
    });
  }

  checkEmail(data): Observable<any> {
    return this.http.get(this.SERVER_API + '/CheckEmail?EmailID=' + data).map((res: Response) => {
      return res;
    });
  }

  getAlumniDuplicateList(data): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetAlumniDuplicateList?EmailID=' + data).map((res: Response) => {
      return res;
    });
  }

  public getDetailsByAlumniID(data): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetEmployementListByAlumniID?AlumniID=' + data).map((res: Response) => {
      return res;
    });
  }

  public getMonthListForGraduatedDate(): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetMonthListForGraduatedDate').map((res: Response) => {
      return res;
    });
  }

  public getYearListForGraduatedDate(): Observable<any> {
    return this.http.get(this.SERVER_API + '/GetYearListForGraduatedDate').map((res: Response) => {
      return res;
    });
  }

  public getCity(): Observable<any> {
    return this.http.get('./assets/world-cities_json.json').map((res: Response) => {
      return res;
    });
  }
}
